import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiSend } from 'react-icons/fi';
import { fadeIn } from '../variants';

const Contact = ({ selectedService = '', onSelectedServiceChange }) => {
  const [status, setStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    setIsSubmitting(true);
    setStatus('Sending show request...');

    try {
      const response = await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData).toString(),
      });

      if (!response.ok) {
        throw new Error('Netlify form submission failed.');
      }

      setStatus('Thanks. Your show request has been sent.');
      onSelectedServiceChange?.('');
      form.reset();
    } catch {
      setStatus('Something went wrong. Please email actionfifi@gmail.com.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id='contact' className='page-section flex items-center'>
      <div className='section-shell'>
        <motion.form
          variants={fadeIn('up', 0.1)}
          initial={false}
          whileInView='show'
          viewport={{ once: true, amount: 0.25 }}
          className='panel w-full'
          name='contact'
          method='POST'
          action='/'
          data-netlify='true'
          data-netlify-honeypot='bot-field'
          onSubmit={handleSubmit}
        >
          <input type='hidden' name='form-name' value='contact' />
          <p hidden>
            <label>
              Do not fill this out: <input name='bot-field' />
            </label>
          </p>
          <p className='section-kicker'>Contact</p>
          <h2 className='mb-5 text-[32px] font-bold leading-tight text-accent md:text-[42px]'>
            Bring FMX to your crowd
          </h2>
          <p className='mb-8 w-full text-base leading-8 text-white/60'>
            Send the date, location, and show setup. I&apos;ll help you lock in
            the right option, from full airbag and ramp logistics to a rider
            appearance at your event.
          </p>

          <div className='grid gap-5 md:grid-cols-2'>
            <input
              className='h-[54px] rounded-[8px] border border-white/10 bg-primary px-5 text-sm text-white outline-none transition placeholder:text-white/35 focus:border-accent'
              name='firstName'
              placeholder='Firstname'
              required
            />
            <input
              className='h-[54px] rounded-[8px] border border-white/10 bg-primary px-5 text-sm text-white outline-none transition placeholder:text-white/35 focus:border-accent'
              name='lastName'
              placeholder='Lastname'
              required
            />
            <input
              className='h-[54px] rounded-[8px] border border-white/10 bg-primary px-5 text-sm text-white outline-none transition placeholder:text-white/35 focus:border-accent'
              type='email'
              name='email'
              placeholder='Email address'
              required
            />
            <input
              className='h-[54px] rounded-[8px] border border-white/10 bg-primary px-5 text-sm text-white outline-none transition placeholder:text-white/35 focus:border-accent'
              name='phone'
              placeholder='Phone number'
            />
          </div>

          <select
            className='mt-5 h-[54px] w-full rounded-[8px] border border-white/10 bg-primary px-5 text-sm text-white outline-none transition focus:border-accent'
            name='service'
            value={selectedService}
            onChange={(event) => onSelectedServiceChange?.(event.target.value)}
            required
          >
            <option value='' disabled>
              Select a service
            </option>
            <option>FMX Show Organization</option>
            <option>FMX Rider Appearance</option>
          </select>

          <textarea
            className='mt-5 min-h-[170px] w-full resize-none rounded-[8px] border border-white/10 bg-primary px-5 py-4 text-sm text-white outline-none transition placeholder:text-white/35 focus:border-accent'
            name='message'
            placeholder='Type your message here.'
            required
          />

          <div className='mt-6 flex flex-col gap-4 sm:flex-row sm:items-center'>
            <button
              type='submit'
              className='pill-button w-fit disabled:cursor-not-allowed disabled:opacity-60'
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : 'Send message'} <FiSend size={18} />
            </button>
            {status && (
              <p className='text-sm leading-6 text-white/55' role='status'>
                {status}
              </p>
            )}
          </div>
        </motion.form>
      </div>
    </section>
  );
};

export default Contact;
